import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import { Modal as VxeModal } from 'vxe-table'
import 'vxe-table/lib/style.css'

Vue.use(ElementUI);
Vue.use(VxeModal);
Vue.config.productionTip = false

// 添加全局样式来覆盖Element UI的下拉菜单
const style = document.createElement('style');
style.textContent = `
  /* 强制覆盖Element UI下拉菜单样式 - 使用更精确的选择器 */
  .el-menu--horizontal .el-submenu .el-menu,
  .el-menu--horizontal .el-submenu .el-menu.el-menu--popup {
    background-color: #a00000 !important;
    border: 1px solid #8c2e2d !important;
  }
  
  .el-menu--horizontal .el-submenu .el-menu .el-menu-item,
  .el-menu--horizontal .el-submenu .el-menu.el-menu--popup .el-menu-item {
    color: #FFD700 !important;
    background-color: #a00000 !important;
  }
  
  .el-menu--horizontal .el-submenu .el-menu .el-menu-item:hover,
  .el-menu--horizontal .el-submenu .el-menu.el-menu--popup .el-menu-item:hover {
    background-color: #8c2e2d !important;
    color: #FFD700 !important;
  }
  
  /* 针对Element UI的弹出菜单 */
  .el-menu--popup {
    background-color: #a00000 !important;
    border: 1px solid #8c2e2d !important;
  }
  
  .el-menu--popup .el-menu-item {
    background-color: #a00000 !important;
    color: #FFD700 !important;
  }
  
  .el-menu--popup .el-menu-item:hover {
    background-color: #8c2e2d !important;
    color: #FFD700 !important;
  }

  .el-menu--popup .el-submenu__title,
  .el-menu--popup .el-submenu.is-opened > .el-submenu__title,
  .el-menu--popup .el-submenu.is-active > .el-submenu__title,
  .el-menu--popup .el-submenu:focus > .el-submenu__title,
  .el-menu--popup .el-submenu__title:hover,
  .el-menu--popup .el-submenu__title:focus {
    background-color: #a00000 !important;
    color: #FFD700 !important;
  }

  .el-menu--popup .el-submenu__icon-arrow {
    color: #FFD700 !important;
  }
  
  /* 确保下拉菜单显示在最上层 */
  .el-submenu .el-menu,
  .el-menu--popup {
    z-index: 1001 !important;
  }
`;

document.head.appendChild(style);

// 监听DOM变化，动态应用样式
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.type === 'childList') {
      const dropdowns = document.querySelectorAll('.el-submenu .el-menu, .el-menu--popup');
      dropdowns.forEach(function(dropdown) {
        dropdown.style.setProperty('background-color', '#a00000', 'important');
        dropdown.style.setProperty('border', '1px solid #8c2e2d', 'important');
        
        const items = dropdown.querySelectorAll('.el-menu-item');
        items.forEach(function(item) {
          item.style.setProperty('background-color', '#a00000', 'important');
          item.style.setProperty('color', '#FFD700', 'important');
        });
        const titles = dropdown.querySelectorAll('.el-submenu__title');
        titles.forEach(function(title) {
          title.style.setProperty('background-color', '#a00000', 'important');
          title.style.setProperty('color', '#FFD700', 'important');
          const arrow = title.querySelector('.el-submenu__icon-arrow');
          if (arrow) arrow.style.setProperty('color', '#FFD700', 'important');
        });
      });
    }
  });
});

// 开始观察DOM变化
observer.observe(document.body, {
  childList: true,
  subtree: true
});

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
